style {
    .ui-heading {
        font-family: var(--header-font) !important;
    }
}

ui-text.ui-heading class=input.class id=input.id tag="h"+(input.heading||2) ...input
    <${input.renderBody}/>